'use strict';

var React = require('react');
var utils = require('./utils-CqsSjtb2.js');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var styled = require('styled-components');
var jsUtils = require('@swiggy-private/js-utils');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    margin: `0 ${theme.spacing.medium}`,
}));
const DotSeparator = styled__default.default(Text.Text)(({ theme }) => ({
    margin: `0 ${theme.spacing.xSmall}`,
}));
const Strike = styled__default.default(Text.Text) `
    text-decoration: line-through;
    margin-right: 4px;
`;
const Price = styled__default.default.span `
    & > *::before {
        content: "\\20B9";
        margin-right: 0.1rem;
    }
`;
const Flex = styled__default.default.div `
    display: flex;
    align-items: center;
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

const BasicItemInfo = (props) => {
    const { itemData, showPrice } = props;
    const priceRange = utils.getPriceRange(itemData);
    const finalPrice = utils.getFinalPrice(itemData);
    const price = utils.getPrice(itemData);
    return (React__default.default.createElement(Flex, null,
        React__default.default.createElement(Text.Text, { variant: "V2.body2.neutral.regular", color: "text_Med_Emphasis", "aria-hidden": true }, utils.getName(itemData)),
        !jsUtils.isEmpty(priceRange) && showPrice ? (React__default.default.createElement(React__default.default.Fragment, null,
            React__default.default.createElement(DotSeparator, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, "\u2022"),
            React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular", "aria-hidden": true }, priceRange))) : (React__default.default.createElement(React__default.default.Fragment, null,
            price > finalPrice && showPrice && (React__default.default.createElement(React__default.default.Fragment, null,
                React__default.default.createElement(DotSeparator, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, "\u2022"),
                React__default.default.createElement(Price, null,
                    React__default.default.createElement(Strike, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, price)))),
            finalPrice && showPrice && (React__default.default.createElement(React__default.default.Fragment, null,
                React__default.default.createElement(DotSeparator, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, "\u2022"),
                React__default.default.createElement(Price, null,
                    React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, finalPrice))))))));
};
var BasicItemInfo$1 = React__default.default.memo(BasicItemInfo);

exports.BasicItemInfo = BasicItemInfo$1;
//# sourceMappingURL=BasicInfo-DwD6dQA0.js.map
